const DarkTheme = {
    // Global colors
    textColor: "#d6d8de",
    background: "#202020",
    hover: "rgba(100, 100, 100, 0.3)",
    whiteBlack: "#fff",

    // Folder
    folderNameBarBg: "#444",
    folderBorder: "#444",
    folderNameBarBtnHover: "rgba(200, 200, 200, 0.2)",
    folderHoverBg: "rgba(174, 192, 229, 0.1)",
    folderHoverOutline: "rgb(220, 227, 242, 0.5)",
    folderFocusBg: "rgba(174, 192, 229, 0.2)",
    folderFocusOutline: "rgb(220, 227, 242, 0.7)",
    backButtonColor: "#26c11b",

    // Settings App
    settingsBg: "rgba(174, 192, 229, 0.2)",
    settingsOutline: "rgb(220, 227, 242, 0.5)",

    // Calculator App
    calcNumButtonBg: "#000",
    calcOperatorButtonBg: "#0f0f0f",
    calcNumButtonHover: "#101010",
    calcOperatorButtonHover: "#212121",

    // Clock and Logo
    clockHover: "rgba(100, 100, 100, 0.3)",
    logoHover: "rgba(100, 100, 100, 0.3)",
    logoBorder: "#f80012",

    // StartMenu
    startMenuBg: "rgba(32, 32, 32, 0.95)",
    startSmallWidgetColor: "#d6d8de",
    startSmallWidgetHover: "rgba(100, 100, 100, 0.3)",

    // Taskbar Icons
    iconBg: "rgba(255, 255, 255, 0.1)",
    iconBgHover: "rgba(200, 200, 200, 0.2)",

    // Calendar
    calendarBg: "rgba(32, 32, 32, 0.95)",
    calendarBorder: "#444",
    calendarColorDefault: "#d6d8de",
    calendarColorPrimary: "#fff",
    calendarColorSecondary: "#bababa",
    calendarColorCurrentDate: "#000",
    calendarBgCurrentDate: "#006edc",
    calendarTodayClock: "#4b8af2",
    calendarColorNeighboringMonth: "#969696"
};

export default DarkTheme;
